import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import { useAppSelector } from '../../../../hooks';
import { selectLastUpdatedSummary } from '../../../../slices/utils/utilsSlice';
import { getTimeDiff } from '../../../../components/Notifications/utils';

const OrderCountSummaryTable = React.lazy(() => import('./OrderCountSummaryTable'));

export default function SummaryCard() {
  const [lastUpdated, setLastUpdated] = React.useState<string | null>();
  const lastUpdatedSummary = useAppSelector(selectLastUpdatedSummary);

  const getLastUpdatedString = React.useCallback(() => {
    setLastUpdated(
      lastUpdatedSummary ? `Last updated: ${getTimeDiff(lastUpdatedSummary.toString())}` : '',
    );
  }, [lastUpdatedSummary]);

  React.useEffect(() => {
    var refreshUpdated = setInterval(() => getLastUpdatedString(), 1000);

    return () => clearInterval(refreshUpdated);
  }, [getLastUpdatedString]);

  return (
    <Card raised>
      <CardHeader
        title="Summary - Last 24 hours"
        subheader={lastUpdated}
        action={
          <IconButton aria-label="settings">
            <Icon>more_vert</Icon>
          </IconButton>
        }
        titleTypographyProps={{ color: 'error', fontSize: 20 }}
        subheaderTypographyProps={{ fontSize: 12 }}
        sx={{ pb: 0, pt: 1.5 }}
      />
      <CardContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          pt: 1,
          pl: 1.5,
          pr: 1.5,
          '&:last-child': { pb: 1.5 },
        }}
      >
        <React.Suspense fallback={<CircularProgress />}>
          <OrderCountSummaryTable />
        </React.Suspense>
      </CardContent>
    </Card>
  );
}
